import { Alignment } from '@pixum/types';
import type { ImageInformation } from 'stores/express-designer';

export function getImageAlignment(image: ImageInformation | undefined): Alignment {
  if (!image) return Alignment.LANDSCAPE;

  const width = image.rotatedWidth ?? image.width ?? 0;
  const height = image.rotatedHeight ?? image.height ?? 1;
  const ratio = width / height;

  if (Math.abs(ratio - 1) < 0.1) {
    return Alignment.SQUARE;
  }

  return width > height ? Alignment.LANDSCAPE : Alignment.PORTRAIT;
}
